import { render } from "./reloadResident.vue?vue&type=template&id=41804202"
import script from "./reloadResident.vue?vue&type=script&lang=js"
export * from "./reloadResident.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__